/**
 * Created by Carsten Hibbeler on 07.01.2016.
 * Copyright: xdot GmbH 2015
 */

import { AppContext } from '../app-context';
import ActionTypesCommon from '../constants/ActionTypesCommon';

export default {

    startEditFormItem(formId, item = {}) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypesCommon.START_EDIT_IN_FORM,
            payload: item,
            meta: {
                formId
            }
        });
    },

    stopEditFormItem(formId) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypesCommon.END_EDIT_IN_FORM,
            meta: {
                formId
            }
        });
    },

    changedEditFormItem(formId, item, validation) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypesCommon.EDIT_IN_FORM,
            payload: {
                item,
                validation
            },
            meta: {
                formId

            }
        });
    },

    resetForm(formId) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypesCommon.RESET_FORM,
            meta: {
                formId
            }
        });
    },


    submitForm(apiFn, item, formId, closeForm = true, options) {
        const o = options || {};
        o.meta = {...o.meta,  formId, closeForm };

        return AppContext.getDispatcher().dispatchAsyncOperation(
            ActionTypesCommon.SUBMIT_FORM_ASYNC,
            apiFn,
            item,
            o);
    }


};



// WEBPACK FOOTER //
// ./js/actions/FormActions.js